import { RealtyObject } from 'shared/api/kyrgyzstan/search'

export const getDestinationTitle = (data: RealtyObject | null) => {
  if (!data) return ''

  return `${data.city.city_name}${data.city.region ? `, ${data.city.region}` : ''}`
}
